import React, { useEffect, useState } from 'react';
import {
  Box,
  Switch,
  Typography,
  Paper,
  CircularProgress,
  FormControlLabel,
  Divider,
  Stack,
  Snackbar,
} from '@mui/material';
import { useEmployeeService } from '../../services/EmployeeService';

const ValidationToggle = ({ label, checked, onChange }) => (
  <FormControlLabel
    control={<Switch checked={checked} onChange={onChange} color="primary" />}
    label={<Typography variant="body1">{label}</Typography>}
    sx={{ justifyContent: 'space-between', m: 1, width: '100%' }}
    labelPlacement="start"
  />
);

const EmployeeValidationSettings = ({ empID }) => {
  const { fetchEmployeeValidationRequirement, updateEmployeeValidationRequirement } = useEmployeeService();
  const [loading, setLoading] = useState(true);
  const [settings, setSettings] = useState(null);
  const [snackbarMsg, setSnackbarMsg] = useState('');

  const fetchData = async () => {
    setLoading(true);
    try {
      const res = await fetchEmployeeValidationRequirement({ EmployeeId: empID });
      setSettings(res?.[0] || null); 
    } catch (err) {
      console.error('Fetch failed', err);
    }
    setLoading(false);
  };
console.log('setting data',settings)
  const handleChange = (key) => async (e) => {
    const newValue = e.target.checked;
    const updatedSettings = {
      EmployeeId: settings.Group_Employee_Code,
      FaceValidation: key === 'FaceValidation' ? newValue : settings.FaceValidation,
      LocationValidation: key === 'LocationValidation' ? newValue : settings.LocationValidation,
      LivelinessDetection: key === 'livelinessDetectionRequired' ? newValue : settings.livelinessDetectionRequired,
    };
    try {
      updateEmployeeValidationRequirement(updatedSettings);
      setSettings((prev) => ({ ...prev, [key]: newValue }));
      setSnackbarMsg('Settings updated successfully');
    } catch (err) {
      console.error('Update failed', err);
      setSnackbarMsg('Failed to update settings');
    }
  };

  useEffect(() => {
    if (empID) fetchData();
  }, [empID]);

  if (loading) {
    return (
      <Box display="flex" justifyContent="center" py={4}>
        <CircularProgress />
      </Box>
    );
  }

  if (!settings) {
    return (
      <Box py={4} textAlign="center">
        <Typography variant="body1" color="error">Unable to load data</Typography>
      </Box>
    );
  }

  return (
    <Box sx={{ p: 0, maxWidth: 480, mx: 0, mt: 0 }}>
      {/* <Typography variant="h6" gutterBottom>
        Employee Validation Settings
      </Typography> */}
      
      <Stack spacing={2}>
        <ValidationToggle
          label="Face Validation"
          checked={settings.FaceValidation}
          onChange={handleChange('FaceValidation')}
        />
        <ValidationToggle
          label="Location Validation"
          checked={settings.LocationValidation}
          onChange={handleChange('LocationValidation')}
        />
        <ValidationToggle
          label="Liveliness Detection"
          checked={settings.livelinessDetectionRequired}
          onChange={handleChange('livelinessDetectionRequired')}
        />
      </Stack>
      <Snackbar
        open={!!snackbarMsg}
        autoHideDuration={3000}
        onClose={() => setSnackbarMsg('')}
        message={snackbarMsg}
      />
    </Box>
  );
};

export default EmployeeValidationSettings;
